import { Component, HostListener, OnInit } from '@angular/core';
import { VersionComponent } from 'src/app/refact/shared/components/version/version.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  protected innerWidth = window.innerWidth;
  protected anoAtual = new Date().getFullYear();
  protected currentApplicationVersion = environment.appVersion;
  constructor() { }

  ngOnInit(): void {
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
}
